import React from 'react'
import classNames from 'classnames'
import classes from './styles.module.scss'

export interface IButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void
  children?: React.ReactNode
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary'
  style?: React.CSSProperties
  size?: 'sm' | 'md'
  fullWidth?: boolean
  disabled?: boolean
  className?: string
  type?: "button" | "submit" | "reset"
}

export const Button: React.FC<IButtonProps> = (props) => {
  const {
    onClick = (e: React.MouseEvent<HTMLButtonElement>) => null,
    children,
    variant = 'primary',
    style = {},
    disabled = false,
    size = 'md',
    fullWidth = false,
    className = '',
    type = 'button',
    ...rest
  } = props

  return (
    <button
      onClick={onClick}
      type={type}
      className={classNames(
        classes.button,
        {
          [classes.primary]: variant === 'primary',
          [classes.secondary]: variant === 'secondary',
          [classes.tertiary]: variant === 'tertiary',
          [classes.quaternary]: variant === 'quaternary',
          [classes.sm]: size === 'sm',
          [classes.md]: size === 'md',
          [classes.fullWidth]: fullWidth,
        },
        className
      )}
      style={style}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}